import { User } from "src/app/shared";

export interface UserState {
  users: User[];
}
